const storage = window.sessionStorage;
export const storageKey = 'rezdy';

export const loadState = (key: string) => {
    try {
        const serializedState = storage.getItem(`${storageKey}:${key}`);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (key: string, state: any) => {
    try {
        const serializedState = JSON.stringify(state);
        storage.setItem(`${storageKey}:${key}`, serializedState);
        return true;
    } catch (error) {
        return false;
    }
};

export default {
    loadState,
    saveState,
};
